import styled from '@emotion/styled';
import { themeGet } from '@risk-first/ui-style-utils';

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.white')};
`;
